import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Combinator } from 'modules/queryBuilder/types';
import { REQUIREMENT_COMBINATOR_LABEL } from '../constants';

export const useCombinatorSelectOptions = () => {
  const { t } = useTranslation();
  return [
    { title: t(REQUIREMENT_COMBINATOR_LABEL[Combinator.AND]), value: Combinator.AND },
    { title: t(REQUIREMENT_COMBINATOR_LABEL[Combinator.OR]), value: Combinator.OR },
    { title: t(REQUIREMENT_COMBINATOR_LABEL[Combinator.NOT]), value: Combinator.NOT },
  ];
};
